var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3669 0.629897C13.9991 0.268752 13.5043 0.0664063 12.9889 0.0664062C12.4735 0.0664063 11.9787 0.268752 11.611 0.629897L1.58624 10.6566C1.53945 10.7032 1.50265 10.7589 1.47807 10.8203L0.0971932 14.2652C0.0618683 14.3537 0.0532881 14.4506 0.072515 14.544C0.0917418 14.6374 0.137931 14.723 0.205363 14.7904C0.273235 14.8571 0.358835 14.9028 0.451963 14.9221C0.545091 14.9415 0.64182 14.9336 0.730621 14.8996L4.17647 13.5206C4.23765 13.4958 4.29329 13.459 4.34018 13.4125L14.3669 3.3858C14.7322 3.0203 14.9375 2.52465 14.9375 2.00785C14.9375 1.49104 14.7322 0.99539 14.3669 0.629897V0.629897Z",
    fill: "#357ABC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.e7a3e4aba9b1c36ab58f333188d61042.svg";
export { ForwardRef as ReactComponent };